import React from "react";
import styled from "styled-components";
import {
    primaryButtonShadowColour, subHeaderBackgroundColour, viewAndSubdivideButtonColour
} from "../../style/styleConsts";
import {Tooltip} from "antd";
import {ExportIcon} from "../elements/ExportIcon";

export const ExportButton = styled.a`
  margin-top: auto;
  margin-left: auto;
  margin-bottom: auto;
  margin-right: ${props => props.marginRight};
  border-radius: 3px;
  background-color: ${subHeaderBackgroundColour};
  :active {
    box-shadow: inset 0 2px 3px 0 rgba(0,0,0,0.25);
  }
  cursor: pointer;
  
  ${({disableExportButton}) => !disableExportButton && `
    :hover {
       background-color: ${viewAndSubdivideButtonColour} ;
    }
  `}
 
  ${({addBoxShadow}) => addBoxShadow && `
     box-shadow: 0 3px 1px 0 ${primaryButtonShadowColour};
  `}
`;

const GroupingExportButton = ({
                                  exportUrl,
                                  onExportClick,
                                  onExportDisabledClick = null,
                                  disableExportButton = false,
                                  addBoxShadow = true,
                                  buttonRightMargin = "16px",
                                  imagePadding = '4px',
                                  imageWidth = "23px",
                                  imageHeight = "23px"
                              }) => {

    return (
        <Tooltip title={disableExportButton ? "Subdivided data is not available for download" : null}
                 mouseLeaveDelay={0}
                 placement={"left"}>
            <ExportButton disableExportButton={disableExportButton}
                          marginRight={buttonRightMargin}
                          addBoxShadow={addBoxShadow}
                          href={disableExportButton ? null : exportUrl}
                          onClick={disableExportButton ? onExportDisabledClick : onExportClick}
                          className="t-export-button">
                <ExportIcon disableExportButton={disableExportButton}
                            padding={imagePadding}
                            width={imageWidth}
                            height={imageHeight}/>
            </ExportButton>
        </Tooltip>
    );
};

export default GroupingExportButton;